import { render, staticRenderFns } from "./PartnerMerge.vue?vue&type=template&id=1b2937d1"
import script from "./PartnerMerge.vue?vue&type=script&lang=js"
export * from "./PartnerMerge.vue?vue&type=script&lang=js"
import style0 from "./PartnerMerge.vue?vue&type=style&index=0&id=1b2937d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports